import React from 'react';

import { AModal } from 'components/shared/AModal';
import Button from 'components/shared/Button';
import Text from 'components/shared/Typography/Text';

import s from './index.module.css';

type Props = {
  onClose: () => void;
  onConfirm: () => void;
};

function ConfirmationModal({ onClose, onConfirm }: Props) {
  return (
    <AModal
      wrapperClassName={s.modalWrapper}
      size="xs"
      header="Are you sure?"
      isOpen
      onClose={onClose}
      footer={
        <div className={s.modalFooter}>
          <div className={s.buttonContainer}>
            <Button type="default" size="medium" onClick={onClose}>
              No
            </Button>
          </div>

          <Button type="danger" size="medium" onClick={onConfirm}>
            Yes, I'm sure
          </Button>
        </div>
      }
    >
      <Text type="brandon">Are you sure you want to delete this email template? This cannot be undone.</Text>
    </AModal>
  );
}

export { ConfirmationModal };
